import { useEffect, useState } from "react";
import { IAnnouncement, IUser } from "@/common/api/services/types";
import { useUserStore } from "@/common/store/userStore";
import { loadUserData, loadLastSeenAnnouncement } from "@/common/utils/storage";
import { apiAnnouncements } from "@/common/services";
import { isAuthenticated } from "@/common/services/Auth";

export const useAnnouncement = () => {
  const username = useUserStore((state) => state.currentUser?.username);
  const verified = useUserStore((state) => state.currentUser?.verified);
  const [announcement, setAnnouncement] = useState<IAnnouncement | undefined>(undefined);
  const [lastSeenAnnouncementId, setLastSeenAnnouncementId] = useState<string>(loadLastSeenAnnouncement() || "0");

  useEffect(() => {
    (async() => {
      if (!await isAuthenticated()) {
        return;
      }

      try {
        const { id } = await apiAnnouncements.getLastSeenAnnouncement();
        setLastSeenAnnouncementId(id);
      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  useEffect(() => {
    const userData = loadUserData() as IUser | null;
    const hasUserName = !!(username || userData?.username);

    let userType: "verified" | "unverified" | "anonymous" = "anonymous";

    if (hasUserName) {
      userType = (verified || userData?.verified) ? "verified" : "unverified";
    }

    const candidateAnnouncements = window.announcements?.global?.[userType];
    const candidateAnnouncement = candidateAnnouncements && candidateAnnouncements.find((n) => n.id > lastSeenAnnouncementId);

    setAnnouncement(candidateAnnouncement);
  }, [username, verified, lastSeenAnnouncementId]);

  return { announcement };
};

